"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.navLinkInverseStyle = exports.navLinkStyle = exports.linkStyleInverse = exports.linkStyle = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var linkStyle = (0, _styledComponents.css)(["display:inline;cursor:pointer;color:", ";position:relative;text-decoration:underline ", ";line-height:17pt;text-decoration-color:", ";@property --offset{syntax:'<length>';inherits:false;initial-value:0;}text-underline-offset:var(--offset,0.3em);--offset:0.22em;transition:--offset 200ms;&:hover{--offset:0.35em;opacity:0.9;}&:active{opacity:1;}&:visited{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.link.underlineTextColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xxs;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.link.underlineColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.link.textLinkVisited;
});
exports.linkStyle = linkStyle;
var linkStyleInverse = (0, _styledComponents.css)(["display:inline;cursor:pointer;text-decoration:underline;color:", ";font-weight:", ";@property --offset{syntax:'<length>';inherits:false;initial-value:0;}text-underline-offset:var(--offset,0.1em);--offset:0.1em;transition:--offset 200ms;&:hover{--offset:0.25em;opacity:0.9;}&:active{opacity:1;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.text03;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeight.bold;
});
exports.linkStyleInverse = linkStyleInverse;
var navLinkStyle = (0, _styledComponents.css)(["color:", ";text-decoration:none;white-space:nowrap;outline:none;display:inline-block;&:hover,&:active{color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorText03;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorUI03;
});
exports.navLinkStyle = navLinkStyle;
var navLinkInverseStyle = (0, _styledComponents.css)(["", ";color:", ";"], navLinkStyle, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorText01;
});
exports.navLinkInverseStyle = navLinkInverseStyle;
var Link = _styledComponents.default.a.withConfig({
  displayName: "src__Link",
  componentId: "is1t9k-0"
})(["", ""], function (_ref10) {
  var inverse = _ref10.inverse;
  return inverse ? linkStyleInverse : linkStyle;
});
exports.Link = Link;